import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    Menu,
    MenuItem,
    MenuList,
    MenuPopover,
    MenuTrigger,
    makeStyles,
    mergeClasses,
} from '@fluentui/react-components';
import { useAppSelector } from '../../redux/app/hooks';
import { RootState } from '../../redux/app/store';
import { ResponseStyle } from '../../libs/models/UserPreferences';
import { useUserPreferences } from '../../libs/hooks/useUserPreferences';

const useClasses = makeStyles({
    activeOption: {
        fontWeight: 'bold',
    },
});

export const ResponseStyleSwitcher: React.FC = () => {
    const { t } = useTranslation();
    const classes = useClasses();
    const currentStyle = useAppSelector((state: RootState) => state.app.userPreferences.responseStyle);
    const { updateResponseStyle } = useUserPreferences();

    const onSelect = (style: ResponseStyle) => {
        if (style === currentStyle) {
            return;
        }
        updateResponseStyle(style).catch(() => {
            // Errors are logged inside the hook; nothing to surface here.
        });
    };

    return (
        <Menu>
            <MenuTrigger disableButtonEnhancement>
                <MenuItem>{t('userSettingsMenu.responseStyle.title')}</MenuItem>
            </MenuTrigger>
            <MenuPopover>
                <MenuList>
                    <MenuItem
                        data-testid="responseStyleBrief"
                        className={mergeClasses(currentStyle === ResponseStyle.Brief && classes.activeOption)}
                        onClick={() => {
                            onSelect(ResponseStyle.Brief);
                        }}
                    >
                        {t('userSettingsMenu.responseStyle.brief')}
                    </MenuItem>
                    <MenuItem
                        data-testid="responseStyleDetailed"
                        className={mergeClasses(currentStyle === ResponseStyle.Detailed && classes.activeOption)}
                        onClick={() => {
                            onSelect(ResponseStyle.Detailed);
                        }}
                    >
                        {t('userSettingsMenu.responseStyle.detailed')}
                    </MenuItem>
                </MenuList>
            </MenuPopover>
        </Menu>
    );
};
